// extracted by mini-css-extract-plugin
export default {"cardName":"Detail_cardName__c+Y6j","card-info":"Detail_card-info__-gtW3","card-list":"Detail_card-list__kMpya","card-title":"Detail_card-title__85Cez","card":"Detail_card__16ym9"};